import { appendAPExamTemplate } from '@/functions/idp'

import RIC from './RIC_9'

export default appendAPExamTemplate({
  ...RIC,
  aimName: 'RIC+AP'
})
